import { Component, Input, OnInit } from '@angular/core';
import { MatDialog as MatDialog } from '@angular/material/dialog';

import { Control } from '../../models/control';



@Component({
    selector: 'app-administration',
    templateUrl: './administration.component.html',
    styleUrls: ['./administration.component.sass'],
    standalone: false
})
export class AdministrationComponent implements OnInit {
  
  @Input() menuRoute: string = '';
  @Input() controls: Control[] = [];
  
  constructor(public dialog: MatDialog) { }

  ngOnInit(): void {
  }


  
}
